import React from 'react';
import Rating from '../rating/rating';
import FilterReviews from '../filter/Filter';
import './header.scss';

const Header = (props) => (
    <header onClick={props.toggleCollapsed}>
        <h2>
            {i18n.t('reviews.header.title')}
            <Rating ratingFive={props.ratingFive} totalCount={props.totalCount}/>
        </h2>
        <i className="ficon ficon-chevron-down"/>
        <FilterReviews fetchReviews={props.fetchReviews} type={props.type} lastStar={props.lastStar} pathFinderConfig={props.pathFinderConfig}/>
    </header>
);

Header.defaultProps = {
    toggleCollapsed: null
};

export default Header;



// WEBPACK FOOTER //
// ./src/reviews/header/header.js